import React from 'react';
import { NavLink, Navigate } from 'react-router-dom';

import { Tabs, TabsProps } from 'antd/es';
import { Form, Formik } from 'formik';

import { List } from '@common/typescript/objects/List';

import { rest } from '@app/components/Api';
import SearchField from '@app/components/Forms/SearchField/SearchField';
import SearchFieldAuto from '@app/components/Forms/SearchField/SearchFieldAuto';
import { stateFilter } from '@app/components/LocalCommon/Utils/StateFilter';
import { transformStateList } from '@app/components/LocalCommon/Utils/transformList';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import SimpleMap from '@app/components/UI/SimpleMap/SimpleMap';
import { ListOption } from '@app/objects/SidebarProps';
import { StatesListItem } from '@app/objects/StatesListItem';
import '@app/scss/components/findVet.scss';

const FindVet: React.FC = () => {
	const [states, setStates] = React.useState<Array<StatesListItem>>([]);
	const stateListOptions: Array<ListOption> = [];
	const [currentState, setCurrentState] = React.useState<string>('');
	const [redirect, setRedirect] = React.useState<string>('');
	const [zipCodeQuery, setZipCodeQuery] = React.useState('');

	const items: TabsProps['items'] = [
		{
			key: '1',
			label: 'Location',
			children: <SearchField
				placeholder="Enter your 5-digit ZIP code"
				iconLocation
				widthBorder="2"
				searchBody="/find-a-vet/search"
				setSearch={setZipCodeQuery}
			/>,
		},
		{
			key: '3',
			label: 'State',
			children: (
				<>
					<Formik
						onSubmit={(values) => {
							console.log(values);
						}}
						initialValues={{ state: '' }}
					>
						{(formikBag) => {
							return (
								<Form className="find-vet-page__form-state" autoComplete="off">
									<SearchFieldAuto
										name="state"
										placeholder="Select a state"
										listOptions={stateListOptions}
										formikBag={formikBag}
										onSelect={(value, option) => {
											formikBag.setFieldValue('state', value);
											setCurrentState(`query=${value}`);
										}}
										onChange={(value) => {
											formikBag.setFieldValue('state', value);
										}}
										searchButton={false}
										customFilter={stateFilter}
									/>
									<NavLink
										to={{
											pathname: '/find-a-vet/search',
											search: currentState,
										}}
										state={{ type: 'area' }}
									>
										<button type="submit" className="btn btn-primary btn-md" disabled={!formikBag.values.state}>
											Search
										</button>
									</NavLink>
								</Form>
							);
						}}
					</Formik>
					<SimpleMap
						states={states}
						getTooltip={(state) => `${state.veterinarians} local vets`}
						getFillColor={(state) => (state.veterinarians > 0 ? '#c4bacf' : '#e1dce6')}
						onClick={(state) => {
							setRedirect(`/find-a-vet/search?query=${state.name}`);
						}}
					/>
					{redirect && <Navigate to={redirect} />}
				</>
			),
		},
	];

	React.useEffect(() => {
		rest.get<List<StatesListItem>>('v1/states/').then((res) => setStates(res.list));
	}, []);

	transformStateList(states, stateListOptions);

	return (
		<HelmetProvider>
			<div className="find-vet-page">
				<div className="find-vet-page__inner">
					<h1 className="find-vet-page__title">Find a veterinarian near you</h1>
					<p className="find-vet-page__description">
						Lap of Love veterinarians help families all across the United States.
						<br />
						Search by location or call us now at
						{' '}
						<a href="tel:8559335683" className="inline-block">(855)933-5683</a>
					</p>
					<div className="card-container switcher">
						<Tabs type="card" items={items} />
					</div>
				</div>
			</div>
		</HelmetProvider>
	);
};

export default FindVet;
